import { useEffect, useState } from 'react'

import { NotificationController } from 'core-components/library/popup'

import { fetchPartnersCoverage } from '../../api'
import { IPartnersCoverageGroup } from '../types'

/**
 * Loads partners coverage groups for the selected FY.
 * The top level of the response is a `RTM + GeoMarket` group (the market).
 */
export const usePartnersCoverage = (fYear?: number) => {
  const [data, setData] = useState<IPartnersCoverageGroup[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!fYear) {
      setData([])
      return
    }

    const abortController = new AbortController()
    let isCancelled = false

    setIsLoading(true)

    fetchPartnersCoverage(fYear, abortController.signal).then((groups) => {
      if (isCancelled) {
        return
      }

      if (!groups) {
        NotificationController.showError({ message: 'Fail to fetch Partners Coverage data' })
      }

      setData(groups ?? [])
      setIsLoading(false)
    })

    return () => {
      isCancelled = true
      abortController.abort()
    }
  }, [fYear])

  return { data, isLoading }
}
